"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _Box = require("../Box");

var _Typography = require("../Typography");

var _styleHelpers = require("../styleHelpers");

var _Portal = require("../Portal/Portal");

var _useCustomStyles = require("../utils/useCustomStyles");

var _baseStyle = require("../shared/baseStyle");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Backdrop = _styledComponents.default.div.withConfig({
  displayName: "Modal__Backdrop",
  componentId: "q4z8wl-0"
})(["", " position:fixed;width:100vw;height:100vh;z-index:1000;left:0;top:0;overflow:scroll;background-color:", ";display:flex;justify-content:center;align-items:center;transition:", ";", " ", ""], _baseStyle.baseStyle, (0, _styleHelpers.getComponentStyle)('modal.backdropColor'), (0, _styleHelpers.getComponentStyle)('modal.backdropTransition', _styleHelpers.transitionTransformer), function (props) {
  return props.css;
}, function (props) {
  return props.open ? (0, _styledComponents.css)(["opacity:1;"]) : (0, _styledComponents.css)(["pointer-events:none;opacity:0;"]);
});

var _StyledBackdrop = (0, _styledComponents.default)(Backdrop).withConfig({
  displayName: "Modal___StyledBackdrop",
  componentId: "q4z8wl-1"
})(["", ""], function (p) {
  return p._css;
});

var ModalArea = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalArea",
  componentId: "q4z8wl-2"
})(["", " ", " ", " max-width:", ";margin:auto;min-height:min-content;padding:", ";", ""], _baseStyle.baseStyle, function (props) {
  return !props.open && (0, _styledComponents.css)(["transform:", ";"], (0, _styleHelpers.getComponentStyle)('modal.box.closedTransform'));
}, function (props) {
  return props.animate && (0, _styledComponents.css)(["transition:", ";"], (0, _styleHelpers.getComponentStyle)('modal.box.transition', _styleHelpers.transitionTransformer));
}, (0, _styleHelpers.getComponentStyle)('modal.box.maxWidth.{maxWidth}'), (0, _styleHelpers.getComponentStyle)('modal.padding'), function (props) {
  return props.css;
});

var _StyledModalArea = (0, _styledComponents.default)(ModalArea).withConfig({
  displayName: "Modal___StyledModalArea",
  componentId: "q4z8wl-3"
})(["", ""], function (p) {
  return p._css2;
});

var ModalBox = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalBox",
  componentId: "q4z8wl-4"
})(["", " border-radius:", "px;background-color:", ";padding:", ";box-shadow:", ";", ""], _baseStyle.baseStyle, (0, _styleHelpers.getComponentStyle)('modal.box.borderRadius'), (0, _styleHelpers.getComponentStyle)('modal.box.backgroundColor'), (0, _styleHelpers.getComponentStyle)('modal.box.padding'), (0, _styleHelpers.getComponentStyle)('modal.box.shadow', _styleHelpers.shadowTransformer), function (props) {
  return props.css;
});

var _StyledModalBox2 = (0, _styledComponents.default)(ModalBox).withConfig({
  displayName: "Modal___StyledModalBox2",
  componentId: "q4z8wl-5"
})(["", ""], function (p) {
  return p._css5;
});

var _StyledModalBox = (0, _styledComponents.default)(ModalBox).withConfig({
  displayName: "Modal___StyledModalBox",
  componentId: "q4z8wl-6"
})(["", ""], function (p) {
  return p._css3;
});

var PaneBox = _styledComponents.default.div.withConfig({
  displayName: "Modal__PaneBox",
  componentId: "q4z8wl-7"
})(["", " margin-top:", ";", ""], _baseStyle.baseStyle, (0, _styleHelpers.getComponentStyle)('modal.gap'), function (props) {
  return props.css;
});

var _StyledPaneBox = (0, _styledComponents.default)(PaneBox).withConfig({
  displayName: "Modal___StyledPaneBox",
  componentId: "q4z8wl-8"
})(["", ""], function (p) {
  return p._css4;
});

function Modal(_ref) {
  var children = _ref.children,
      additionalPanes = _ref.additionalPanes,
      TopRightItem = _ref.topRightItem,
      onClose = _ref.onClose,
      title = _ref.title,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'medium' : _ref$maxWidth,
      _ref$animate = _ref.animate,
      animate = _ref$animate === void 0 ? true : _ref$animate,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      customStyles = _ref.customStyles;

  var mouseDownRef = _react.default.useRef(null);

  var getCustomStyles = (0, _useCustomStyles.useCustomStyles)('modal.styles', customStyles);
  (0, _react.useEffect)(function () {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [open]);

  var handleClose = _react.default.useCallback(function (e) {
    // Only close if the mouse down before the click happened directly over the backdrop
    if (e.target === e.currentTarget && !mouseDownRef.current && onClose) {
      onClose();
    }

    mouseDownRef.current = null;
  }, [onClose]);

  return /*#__PURE__*/_react.default.createElement(_Portal.Portal, {
    name: "modal"
  }, /*#__PURE__*/_react.default.createElement(_StyledBackdrop, {
    "data-testid": "pbl-modal-backdrop",
    onClick: handleClose,
    open: open,
    _css: getCustomStyles('backdrop')
  }, /*#__PURE__*/_react.default.createElement(_StyledModalArea, {
    "data-testid": "pbl-modal-area",
    maxWidth: maxWidth,
    open: open,
    animate: animate,
    _css2: getCustomStyles('area')
  }, /*#__PURE__*/_react.default.createElement(_StyledModalBox, {
    "data-testid": "pbl-modal-box",
    onMouseDown: function onMouseDown(e) {
      mouseDownRef.current = e.currentTarget;
    },
    _css3: getCustomStyles('box')
  }, (title || TopRightItem) && /*#__PURE__*/_react.default.createElement(_Box.Flex, {
    "data-testid": "pbl-modal-title-box",
    justifyContent: "space-between"
  }, title && /*#__PURE__*/_react.default.createElement(_Typography.Title, null, title), TopRightItem && /*#__PURE__*/_react.default.createElement(TopRightItem, {
    onClose: onClose
  })), children), additionalPanes && additionalPanes.map(function (pane, i) {
    return /*#__PURE__*/_react.default.createElement(_StyledPaneBox, {
      key: i,
      "data-testid": "pbl-modal-pane",
      _css4: getCustomStyles('paneBox')
    }, /*#__PURE__*/_react.default.createElement(_StyledModalBox2, {
      "data-testid": "pbl-modal-pane-box",
      _css5: getCustomStyles('box')
    }, pane));
  }))));
}